import { createContext, useContext } from "react";

// settings: datos de la empresa · base: ruta secreta actual (ej. /sistema-aldam-2026)
export const AppCtx = createContext(null);
export const useApp = () => useContext(AppCtx);
